import type { FC } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import type {
  TPopoverProps,
} from "@/ui/components/overlay/Popover/Popover.config";

export const Popover: FC<TPopoverProps> = (props) => (
  <PopoverPrimitive.Root {...props} />
);

Popover.displayName = "Popover";
